import ExpandableNote from "./ExpandableNote";

function formatActivityDate(value) {
    if (!value) {
        return "-";
    }

    const date = new Date(value);
    if (Number.isNaN(date.getTime())) {
        return value;
    }

    return date.toLocaleDateString([], {
        month: "2-digit",
        day: "2-digit",
        year: "2-digit",
    });
}

function formatActivityTime(value) {
    if (!value) {
        return "-";
    }

    const date = new Date(value);
    if (Number.isNaN(date.getTime())) {
        return value;
    }

    return date.toLocaleTimeString([], {
        hour: "numeric",
        minute: "2-digit",
    });
}

function ActivityTab({ activityRows = [], activityLoading = false, activityError = "" }) {
    const rows = Array.isArray(activityRows) ? activityRows : [];
    const showLoadingState = activityLoading && rows.length === 0;

    return (
        <section className="tab-panel-container" aria-label="Activity feed">
            <div className="tab-panel-header">
                <div>
                    <h3>Activity</h3>
                    <p className="tab-panel-subtitle">
                        Logged calls, emails, meetings, notes, follow-ups, and voicemails. Sorted newest first.
                    </p>
                </div>
            </div>

            {activityError ? <p className="contact-detail-tab-empty">{activityError}</p> : null}

            {showLoadingState ? (
                <p className="contact-detail-tab-empty">Loading activity...</p>
            ) : rows.length === 0 ? (
                <p className="contact-detail-tab-empty">No activity data yet.</p>
            ) : (
                <table className="tab-panel-table">
                    <thead>
                        <tr>
                            <th>Type</th>
                            <th>Related Deal</th>
                            <th>Outcome</th>
                            <th>Notes</th>
                            <th>User</th>
                            <th>Date</th>
                            <th>Time</th>
                            <th>Next Follow Up</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rows.map((row) => (
                            <tr key={String(row.id)}>
                                <td>{row.type || "-"}</td>
                                <td>{row.relatedDeal || "-"}</td>
                                <td>{row.outcome || "-"}</td>
                                <td><ExpandableNote>{row.notes}</ExpandableNote></td>
                                <td>{row.user || "-"}</td>
                                <td>{formatActivityDate(row.date)}</td>
                                <td>{formatActivityTime(row.time)}</td>
                                <td>{row.nextFollowUp || "-"}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </section>
    );
}

export default ActivityTab;
